/** @file Client-side check of an export request with the server's own ExportOptionsSchema (same paths). */
import { ExportOptionsSchema } from '@pose2d/api/export/exportOptionsSchema';
import type { ExportRequest } from '../../api/exportQuery';

/** One problem; `path` as the server would report it (`options.frameW`). */
export interface ExportIssue {
  path: string;
  message: string;
}

/** A rig's `scale` is the texture scale in (0, 1]; the schema allows up to SCALE_MAX for sprite sheets (W3-61, R1-07). */
const RIG_SCALE: ExportIssue = { path: 'options.scale', message: 'a rig scale is the texture scale, at most 1' };

/** Empty when the schema accepts the options and a rig keeps its scale within (0, 1]. */
export function exportIssues(request: ExportRequest): ExportIssue[] {
  const parsed = ExportOptionsSchema.safeParse(request.options);
  const issues = parsed.success ? [] : parsed.error.issues.map((issue) => ({ path: ['options', ...issue.path.map(String)].join('.'), message: issue.message }));
  const { target, scale } = request.options;
  const rigTooBig = target === 'rig' && scale !== undefined && scale > 1 && !issues.some((issue) => issue.path === RIG_SCALE.path);
  return rigTooBig ? [...issues, RIG_SCALE] : issues;
}
